import ValidaTexto from '../../validadores/ValidaTexto';
import ValidaURL from './ValidaURL'

export default class ValidaPostagens {
    
    static valida(links) {

        return new Promise((resolve,reject) => {

            let rotuloPostagem = null
            try {
                let link = null;
                for (let i=0; i<links.length; i++) {
                    link = links[i].link;
                    rotuloPostagem = `Postagem_${i+1}`
                    link = ValidaTexto.valida(link,rotuloPostagem,false,1024);
                    ValidaURL.valida(rotuloPostagem,link)
                    links[i].link = link
                }
                resolve(links);
            } 
            catch (msgErro) {
                reject(msgErro)
            }
        })
    }
}